import apiFetch from '../apiFetch'

export default function (values, token) {
  return apiFetch({endPoint: `Pedido/verracosPedido`, method: 'POST', body: values, token: token})
}
